module.exports = __webpack_public_path__ + "img/03.152288ea.jpg";